<template>
  <div class="merchant-tree-panel" :class="{ multiple: multiple }" @click.stop>
    <!-- <div class="input-wrap" :id="'input' + _uid" v-if="!isSelect || filterable">
      <Input
        search
        enter-button
        clearable
        v-model="keyword"
        placeholder="输入关键字"
        @input="inputChange"
        @click.native="inputClick"
        @on-search="search($event)"
      />
      <Tooltip v-if="showIcon" placement="top">
        <Icon v-if="showIcon" type="ios-add-circle-outline" @click="$emit('add')" />
        <template #content>
          <p>新增机构或团队</p>
        </template>
      </Tooltip>
    </div> -->
    <!-- <div class="commission-tips" v-if="showConfigTemplateText">“标*的为未配置产品的组织”</div> -->
    <!-- <search-result url="/buz/merchant/search" method="post" ref="searchBox" :source="source" v-if="keyword && isSearch" @selectChange="selectChange" /> -->
    <Tree
      ref="tree"
      :data="searchResultData"
      :render="renderContent"
      @on-select-change="selectChange"
      :check-strictly="true"
      :show-checkbox="multiple"
      @on-check-change="checkChange"
    ></Tree>
  </div>
</template>

<script>
import searchResult from './searchResult';
import vipLevelMixin from '@/api/vipLevelMixin';

export default {
  inject: ['parent'],
  components: { searchResult, vipLevelMixin },
  props: {
    query: {
      default: null,
      type: Object
    },
    onlyChild: {
      default: false,
      type: Boolean
    },
    showGroupLeader: {
      default: false,
      type: Boolean
    },
    showIcon: {
      default: false,
      type: Boolean
    },
    checkChild: {
      default: true
    }, //多选时选择父级是否关联子集
    value: null, //当前选中
    url: null,
    source: null, //1所有，2排除渠道
    multiple: null, //是否显示多选框
    filterable: null, //是否显示查询
    isSelect: null, //是否是下拉选择组件中
    initLoad: {
      default: true
    },
    isAll: {
      //顶级是否可选
      default: true
    },
    selectAllChildren: null,
    showConfigTemplateText: false
  },
  data() {
    return {
      ajaxUrl: '',
      params: {},
      keyword: '',
      isSearch: false,
      treeData: [],
      searchResultData: [],
      list: [],
      searchResultList: [],
      forceInit: false
    };
  },
  watch: {
    value: {
      handler() {
        this.foreachTree(this.searchResultData, this.value);
      },
      deep: true
    }
  },
  mounted() {
    if (this.isSelect || !this.initLoad) {
      return;
    }
    if (this.$route.query.type == 1) {
      //机构
      this.getTreeData(this.$route.query.organizationId);
    } else if (this.$route.query.type == 2) {
      //团队
      this.getTreeData(this.$route.query.groupId);
    } else {
      this.getTreeData();
    }
  },
  methods: {
    init(ajaxUrl, params, forceInit = false) {
      this.forceInit = forceInit;
      if (this.treeData.length && !forceInit) {
        return;
      }
      this.ajaxUrl = ajaxUrl || '';
      this.params = params || null; //此参数传了source就无效
      this.getTreeData();
    },
    setData(data, id) {
      let isArray = data instanceof Array;
      this.list = [];
      this.searchResultList = [];
      // 避免第2次进入初始化数据缓存勾选状态
      this.$nextTick(() => {
        if (this.isSelect) {
          const treeData = this.foreachTree(isArray ? data : [data], this.value);
          this.treeData = JSON.parse(JSON.stringify(treeData));
          this.searchResultData = treeData;
          this.foreachToList(this.treeData, this.list);
          this.foreachToList(this.searchResultData, this.searchResultList);
          // 多选时 无勾选数据默认勾选全部
          if ((this.multiple && !this.value) || !this.value || this.value.length == 0) {
            this.$nextTick(() => {
              this.foreachTreeCheck(treeData, true);
              this.setSelectIdByChecked();
            });
          } else {
            this.emitData();
          }
        } else {
          this.searchResultData = this.foreachTree(isArray ? data : [data], [id]);
          if (!id && !this.forceInit) {
            data.selected = true;
            this.$emit('change', data);
          }
        }
        this.$emit('getTreeData', this.searchResultData, this.list);
      });
    },
    // select中需要手动获取焦点
    inputClick() {
      const input = document.getElementById('input' + this._uid).querySelector('input');
      input.focus();
    },
    // 查询
    inputChange() {
      if (this.isSelect) {
        this.searchKeyword(this.keyword);
      } else {
        this.keyword == '';
        this.isSearch = false;
      }
    },
    search() {
      if (!this.keyword || this.isSelect) {
        return;
      }
      this.isSearch = true;
      this.$nextTick(() => {
        this.$refs.searchBox.search(this.keyword);
      });
    },
    getTreeData(id) {
      console.log('id------', id)
      this.search();
      const ajaxUrl = this.url || this.ajaxUrl || '/buz/organizationBase/read/tree';
      const params = this.query || this.params;
      this.list = [];
      this.$http({
        url: ajaxUrl,
        type: 'post',
        data: params
      }).then(res => {
        if (this.onlyChild) {
          this.setData(res.data.children);
        } else {
          this.rootId = res.data.id;
          res.data.isTop = true;
          if (!this.isAll) {
            res.data.disabled = true;
          }
          this.setData(res.data, id);
        }
      });
    },
    searchKeyword(keyword) {
      let arr = JSON.parse(JSON.stringify(this.treeData));
      if (keyword) {
        this.searchResultData = this.filterTree(arr, keyword);
      } else {
        this.searchResultData = arr;
      }
      this.searchResultList = [];
      this.foreachToList(this.searchResultData, this.searchResultList);
    },
    // 搜索关键字字段过滤
    filterTree(arr, keyword) {
      let emptyArr = [];
      for (let item of arr) {
        if (item.name.indexOf(keyword) != -1 || (item.code && item.code.indexOf(keyword) != -1)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //   item.children = this.filterTree(item.children, keyword);
          // }
          emptyArr.push(item);
        } else if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          item.children = this.filterTree(item.children, keyword);
          if (item.children.length) {
            emptyArr.push(item);
          }
        }
      }
      return emptyArr;
    },
    foreachTree(treeData, ids = [], parentVipLevel = 999) {
      const list = [];
      treeData.forEach(item => {
        item.vipLevel = (item.vipLevel || '') + '';
        this.$set(item, 'expand', true);
        this.$set(item, 'parentVipLevel', parentVipLevel);
        if (ids.includes(item.id)) {
          this.$set(item, 'selected', true);
          this.$set(item, 'checked', true);
          if (!this.isSelect) {
            this.$emit('change', item);
          }
        } else {
          this.$set(item, 'selected', false);
          this.$set(item, 'checked', false);
        }
        if (item.children && item.children.length) {
          item.children = this.foreachTree(item.children, ids, item.vipLevel);
        }
        if (item.nodeType * 1 === 2) {
          // 团队, 只显示顶级转介人下的直属团队
          if (item.parentId === this.rootId) {
            list.push(item);
          }
        } else {
          list.push(item);
        }
      });
      return list;
    },
    // 扁平化数据
    foreachToList(treeData, list) {
      treeData.forEach(item => {
        list.push(item);
        if (item.children && item.children.length) {
          this.foreachToList(item.children, list);
        }
      });
    },
    // 回调数据
    emitData() {
      if (!this.value) {
        return;
      }
      const list = this.list.filter(item => {
        return this.value == item.id || this.value.includes(item.id);
      });
      if (this.multiple) {
        this.$emit('change', {}, list);
      } else {
        this.$emit('change', list[0] || {}, list);
      }
    },
    renderContent(h, { root, node, data }) {
      let hasChild = data.children && data.children.length ? 'has-child' : '';
      let renderIcon = '';

      // 0-转介人 1-机构 2-团队
      const nodeType = data.nodeType * 1;
      if (!data.isTop) {
        if (nodeType === 1 && data.status == 1) {
          renderIcon = <span class={`tree-icon blue ${hasChild}`}>机构</span>;
        } else if (nodeType === 1) {
          renderIcon = <span class={`tree-icon ${hasChild}`}>机构</span>;
        }
      }

      let name = '';
      if (data.code) {
        name = data.name + '-' + data.code;
      } else {
        name = data.name;
      }
      let noLeader = ''
      let dian = '';
      let levelDom = '';
      let vipLevelDom = '';

      if(this.showGroupLeader && !data.groupLeaderId && nodeType != 0){
        noLeader = <span>(无团队长)</span>;
      }
      if (nodeType === 0) {
        // 只有转介人节点才显示状态
        dian = <span class={data.status == 1 ? 'dian green' : 'dian red'}></span>;

        // 只有转介人节点才显示用户等级
        if (data.vipLevel) {
          // if (this.parent && this.parent.vipLevelList) {
          //   const nodeData = this.parent.vipLevelList.find(item => item.value == data.vipLevel);
          //   if (nodeData && nodeData.label) {
          //     vipLevelDom = <span>-{nodeData.label}</span>;
          //   } else {
          //     vipLevelDom = <span>-VIP{data.vipLevel}</span>;
          //   }
          // } else {
          //   vipLevelDom = <span>-VIP{data.vipLevel}</span>;
          // }
        }

        // 只有转介人节点才显示级别
        levelDom = <span>【{data.level}级】</span>;
      }
      return (
        <div class="tree-item" id={data.id}>
          {dian}
          {renderIcon}
          <span style={{ color: '#C78D49', marginRight: '2px', fontWeight: 'bold' }}>
            {this.showConfigTemplateText && data.hasProduct == '0' && data.levelCode != 10001 && !data.isTop ? '* ' : ''}
          </span>
          <span class={`org-name ${data.isTop ? 'isTop' : ''}`}>{name}</span>
          {vipLevelDom}
          {noLeader}
        </div>
      );
    },
    // 点击文字选择 多选模式效果与点击多选框一致
    selectChange(arr, data) {
      if (this.multiple) {
        //多选
        if (this.checkChild) {
          //关联子集
          this.selectChild(data.id, data.selected); //方法内部emit
        } else {
          // 同步数据
          const bean = this.list.find(item => item.id == data.id);
          if (bean) {
            this.$set(bean, 'selected', !data.checked);
            this.$set(bean, 'checked', !data.checked);
          }
          const selectArr = this.list.filter(item => item.checked);
          this.$emit('change', data, selectArr);
        }
      } else {
        this.$emit('change', data, arr);
        this.list.forEach(item => {
          if (item.id == data.id) {
            item.selected = true;
            item.checked = true;
          } else {
            item.selected = false;
            item.checked = false;
          }
        });
      }
    },
    // 多选框勾选
    checkChange(arr, data) {
      //只在多选模式触发
      if (this.checkChild) {
        //关联子集
        this.selectChild(data.id, data.checked); //方法内部emit
      } else {
        // 同步数据
        const bean = this.list.find(item => item.id == data.id);
        if (bean) {
          this.$set(bean, 'selected', data.selected);
          this.$set(bean, 'checked', data.checked);
        }
        const selectArr = this.list.filter(item => item.checked);
        this.$emit('change', data, selectArr);
      }
    },
    // 勾选子集
    selectChild(id, checked = true) {
      const data = this.searchResultList.find(item => item.id == id);
      this.foreachTreeCheck([data], checked);
      this.setSelectIdByChecked();
    },
    // 勾选所有节点
    foreachTreeCheck(treeData, checked = true) {
      treeData.forEach(item => {
        this.$set(item, 'checked', checked);
        if (item.children && item.children.length) {
          this.foreachTreeCheck(item.children, checked);
        }
      });
      return treeData;
    },
    // 根据checked状态同步选中id
    setSelectIdByChecked() {
      this.list.forEach(item1 => {
        const data = this.searchResultList.find(item2 => item1.id == item2.id);
        if (data) {
          this.$set(item1, 'checked', data.checked);
          this.$set(item1, 'selected', data.selected);
        }
      });
      const nodes = this.searchResultList.filter(item => item.checked);
      this.$emit('change', {}, nodes);
    },
    // 多选模式 查找是否有未勾选的节点
    findNoSelect(arr) {
      return arr.find(item => {
        if (item.checked) {
          if (item.children && item.children.length) {
            return this.findNoSelect(item.children);
          } else {
            return false;
          }
        } else {
          return item;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './merchantTree.scss';
</style>
